import { configureStore } from '@reduxjs/toolkit';

import { stockApi } from './domains/stock';
import { authApi, authReducer } from './domains/auth';

// import { viewReducer } from "./domains/view";

export const store = configureStore({
  reducer: {
    [stockApi.reducerPath]: stockApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    auth: authReducer,
    // view: viewReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat([stockApi.middleware, authApi.middleware]),
});
